import { z } from 'zod'
import { addressPrimitiveSchema } from './primitive'

export const evmAddressSchema = z.object({
  chainId: z.number().int(),
  address: addressPrimitiveSchema,
  label: z.string().optional(),
  isSpam: z.boolean().optional(),
  app: z.string().optional(),
  abi: z.string().optional(),
})

export type EvmAddress = z.infer<typeof evmAddressSchema>
